<template>
  <mdb-container class="gp-has-header">
    <h4 class="text-left">
      <mdb-icon color="primary" icon="key"/>
      API Keys
    </h4>
    <div class="text-left" v-if="loggedIn">
      <mdb-card class="mb-4">
        <mdb-card-body>
          <p>
            This is for advanced users only. API keys let you access {{settings.siteName}} outside of the web application --
            usually
            via an external application or program. Keys are like passwords and should be protected. Anyone with your key can
            act on your behalf as if you were using the web application directly.
          </p>
          <p>API documentation has not yet been developed, but if you have a programmatic need to access information,
            please send a private message and let us know how you'd like to access your data.
          </p>

        </mdb-card-body>
      </mdb-card>
      <mdb-btn @click="showCreateModal=true" icon="plus-circle">New Key</mdb-btn>
      <mdb-tbl class="text-left" responsive striped v-if="keys.length>0">
        <mdb-tbl-head class="primary-color text-white">
          <tr>
            <th>Label</th>
            <th>Access</th>
            <th>Key</th>
            <th></th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr :id="'key-'+k.id" :key="k.id" v-for="k in keys">
            <td>{{k.label}}
              <p v-if="k.currentKey">
                <mdb-badge>This Session</mdb-badge>
              </p>
            </td>
            <td>{{k.access}}</td>
            <td>
              {{ k.authKey }}
              <div v-if="k.secret">
                SECRET:
                <a @click.prevent="k.visible=true" href="">
                  <mdb-icon icon="eye" v-if="!k.visible"/>
                </a>
                <a @click.prevent="k.visible=false" href="">
                  <mdb-icon icon="eye-slash" v-if="k.visible"/>
                </a>
                <p v-if="k.visible">{{k.secret}}</p>
              </div>
            </td>
            <td>
              <!--<mdb-btn @click="getHistory(k)" icon="history" rounded size="sm">Recent Usage</mdb-btn> -->
              <mdb-btn @click="revoke(k)" color="danger" icon="trash" rounded size="sm" v-if="!k.currentKey">Revoke
              </mdb-btn>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>

    <mdb-modal @close="showCreateModal = false" size="lg" v-if="showCreateModal">
      <mdb-modal-header :close="true" class="primary-color text-white">
        Generate New Key
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div>
          <h5>Type</h5>
          <mdb-input id="type-v" label="View Only" name="view" radioValue="View" type="radio"
                     v-model="newKey.accessType"/>
          <mdb-input id="type-u" label="View/Update" name="update" radioValue="Update" type="radio"
                     v-model="newKey.accessType"/>
        </div>
        <mdb-input label="Description" placeholder="Give this key a label so you will recognize it in the list."
                   type="text"
                   v-model="newKey.label"/>
        <div class="text-danger">
            Once your key is generated, you will only be able to retrieve the secret while on this page. After that,
            it will no longer be accessible and you will need to generate a new key.
        </div>
        <mdb-btn :disabled="!newKey.label" @click="generateKey" color="success" icon="save">Create</mdb-btn>
        <mdb-btn color="danger" icon="times-plus" @click="showCreateModal = false">Cancel</mdb-btn>
      </mdb-modal-body>

    </mdb-modal>

    <mdb-modal @close="showHistoryModal = false" size="lg" v-if="showHistoryModal">
      <mdb-modal-header :close="true" class="primary-color text-white">
        Stats
      </mdb-modal-header>
      <mdb-modal-body>
        <div v-if="history.length==0">
          This key has never been used.
        </div>
        <mdb-tbl class="text-left" responsive striped v-if="history.length>0">
          <mdb-tbl-head class="primary-color text-white">
            <tr>
              <th>Date</th>
              <th>IP Address</th>
              <th>Type</th>
              <th>Endpoint</th>
              <th>UI Version</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(h,i) in history">
              <td>
                {{h.lastAccessed}}
              </td>
              <td>
                {{h.ipAddress}}
              </td>
              <td>
                {{h.accessType}}
              </td>
              <td>
                {{h.endpoint}}
              </td>
              <td>
                {{h.uiVersion}}
              </td>

            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-modal-body>
    </mdb-modal>
    <yes-no-modal @no="showDeleteModal=false" @yes="revokeKey"
                  question="Are you sure you wish to revoke this key?" v-if="showDeleteModal"/>

  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi'
import YesNoModal from "./common/YesNoModal";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
    name: 'Keys',
    components: {
      mdbBtn,
      mdbContainer,
      mdbBadge,
      mdbIcon,
      mdbTbl,
      mdbTblHead,
      mdbTblBody,
      mdbCard,
      mdbCardBody,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbModalFooter,
      mdbInput,
      YesNoModal
    },
    computed: {
      loggedIn: function () {
        return this.$store.state.loggedIn
      },
      settings: function () {
        return this.$store.state.settings
      }
    },
    data() {
      return {
        keys: [],
        history: [],
        showCreate: false,
        deleteCandidate: null,
        showCreateModal: false,
        showDeleteModal: false,
        showHistoryModal: false,
        newKey: {
          accessType: "View",
          label: ""
        }
      }
    },
    mounted() {
      document.title = "API Keys";
      this.$store.dispatch("setExecuting", true)
      let url = "/user/keys/"
      api.get(url).then(
        (results) => {
          this.keys = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      revoke(key) {
        this.deleteCandidate = key
        this.showDeleteModal = true
      },
      revokeKey() {
        let key = this.deleteCandidate
        this.$store.dispatch("setExecuting", true)
        let url = "/user/revokeKey/" + key.id
        api.delete(url).then(
          (results) => {
            let loc = this.keys.indexOf(key)
            this.keys.splice(loc, 1)
            this.showDeleteModal = false
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      generateKey() {
        let url = "/user/generateKey/"
        this.showCreateModal = false
        this.$store.dispatch("setExecuting", true)
        api.post(url, this.newKey).then(
          (results) => {
            this.keys.unshift(results.data)
          },
          (error) => {
            this.showCreateModal = true
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      getHistory(key) {
        this.$store.dispatch("setExecuting", true)
        let url = "/user/keyHistory/" + key.id
        api.get(url).then(
          (results) => {
            this.history = results.data
            this.showHistoryModal = true
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }
  }
  ;
</script>

